import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/challenge-list-bg-item-1.png'
import _imports_1 from '../images/challenge-card-item-1.png'
import _imports_2 from '../images/together_tag.png'
import _imports_3 from '../images/eyes.png'


const _withScopeId = n => (_pushScopeId("data-v-79a0c855"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper relative overflow-hidden" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "챌린지 배너",
  class: "challenge-list-bg-item-1"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "text-center white-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-Anton display-3 text-30 text-87" }, " Challenge ", -1))
const _hoisted_6 = { class: "sub-title preline" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-normal" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-12 preline lh-sm text-44" }, [
    /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`캠페인 참여자로 선정되지 않을까 지원을 망설이신다고요?\n1회차에 선정되지 못했다면`) + " "),
    /*#__PURE__*/_createElementVNode("div", {
      class: "mt-sm-2 fw-normal text-12 fw-md-bold",
      style: {"color":"#e5e5ad"}
    }, " 2회차 지원 시 선정 확률 50% UP ")
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "text-12 text-44 lh-sm"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 작은 실천이 모여 지속 가능한 캠퍼스 문화를 만듭니다. ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 지금, 당신의 학교가 바꿀 차례예요! ")
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-sm-5 pt-sm-5" }, null, -1))
const _hoisted_16 = { class: "d-flex flex-column justify-content-center align-items-center gap-sm-5 gap-4 mt-5 mt-sm-0 pt-5 px-3 px-sm-0" }
const _hoisted_17 = {
  key: 3,
  class: "parabola",
  src: _imports_3,
  alt: ""
}
const _hoisted_18 = {
  key: 4,
  src: _imports_1,
  width: "180",
  alt: "챌린지 카드 이미지",
  style: {"position":"absolute","bottom":"-6.5rem","left":"-0.5rem","transform":"rotate(67deg)"},
  class: "d-none d-sm-block"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-sm-5" }, null, -1))
const _hoisted_20 = { class: "d-flex flex-column justify-content-center align-items-center gap-4 gap-sm-5 gap-sm-3 pt-5 mt-5 mt-sm-0" }

import ChallengeCard from '@/templates/campaign-cocacola-season-6/components/challenge-card.vue';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';
import { computed, inject } from 'vue';
import { formatDate, formatDateRange } from '@/templates/campaign-cocacola-season-6/static';
import type { Challenge } from './model/challenge';
import { request } from '@/utils';
import { IProgram } from '@/types/program';

interface Props {
  challenges: Challenge[];
  challengeType: 'everyone' | 'campus';
  hideParticipateButton?: boolean;
  showAdditionalButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenges: null,
    challengeType: null,
    hideParticipateButton: { type: Boolean },
    showAdditionalButton: { type: Boolean }
  },
  emits: ['show-error'],
  setup(__props: any, { emit }) {

const props = __props as {
  challenges: Challenge[];
  challengeType: 'everyone' | 'campus';
  hideParticipateButton?: boolean;
  showAdditionalButton?: boolean;
}


const participate = inject<((challengeType: 'everyone' | 'campus') => Promise<void>)>('participate');
const collect = inject<((challengeType: 'everyone' | 'campus', programz?: IProgram, additionalBox?: boolean) => Promise<void>)>('collect');
const everyone_round1_progId = inject('everyone_round1_progId');
const everyone_round2_progId = inject('everyone_round2_progId');


const isDateInRange = (date: Date, from: Date, to: Date): boolean => {
  return date >= from && date <= to;
};

const isRecruitmentOutOfDate = computed(() => {
  const now = new Date();
  return !challenges.value.some(challenge =>
      challenge.recruitmentFrom && challenge.recruitmentTo &&
      isDateInRange(now, challenge.recruitmentFrom, challenge.recruitmentTo)
  );
});

const isCollectionOutOfDate = computed(() => {
  const now = new Date();
  return !challenges.value.some(challenge => {
    return challenge.collectionFrom && challenge.collectionTo &&
           isDateInRange(now, challenge.collectionFrom, challenge.collectionTo);
  }

  );
});


const challenges = computed(() => props.challenges);



async function getProgram(id: number) {
  return request.get(`programs/${id}`);
}

const isParticipatedEveryone = (program: IProgram) => {
  return program.participation_request_id;
};

async function handleParticipateClick() {
  if (isRecruitmentOutOfDate.value) {
    emit('show-error', '참여신청 기간이 아닙니다');
    return;
  }

  const round1Data = await getProgram(everyone_round1_progId as number);
  const round2Data = await getProgram(everyone_round2_progId as number);
  //Validate rounds
  if (props.challengeType === 'campus') {
    if (isParticipatedEveryone(round1Data.data) || isParticipatedEveryone(round2Data.data)) {
      emit('show-error', '이미 \'모두의 챌린지\'에 참여하셨습니다.');
      return '❌ Cannot apply to the \'Campus\'s Challenge\' because you were selected in the 1st or 2nd round';
    }
  }

  if (props.challengeType === 'everyone') {
    if (isParticipatedEveryone(round1Data.data)) {
      emit('show-error', '이미 \'모두의 챌린지\' 1회차에 참여하셨습니다.');
      return '❌ Cannot apply to the 2nd \'Everyone\'s Challenge\' because you were selected in the 1st';
    } else if (isParticipatedEveryone(round2Data.data)) {
      emit('show-error', '이미 \'모두의 챌린지\' 2회차에 참여하셨습니다.');
      return '❌ Cannot apply to the 1st \'Everyone\'s Challenge\' because you were selected in the 2nd';
    }
  }

  participate?.(props.challengeType)
      .catch(() => {
        emit('show-error', '참여신청에 실패했습니다. 다시 시도해주세요.');
      });
};

const isDateInRangeOfCollection = (rounds: any[]) => {
  const now = new Date();

  return rounds.some((round: any) =>
    isDateInRange(now, new Date(round.collection_started_at), new Date(round.collection_ended_at))
  );
};

const isParticipated = async (everyone_prog_id: Number) => {
  try {
    const records = await request.get('user_requests', {
      params: {
        target_id_eq: everyone_prog_id,
        target_type_eq: 'Program',
        type_eq: 'ParticipationRequest'
      }
    });
    return records.data && records.data.length > 0 && records.data.find((r: any) => r.original_state === 'approved');
  } catch (error) {
    return false;
  }
};

const handleAdditionalClick = async () => {
  collect?.(props.challengeType, undefined, true)
    .catch(() => {
      emit('show-error', '수거신청에 실패했습니다. 다시 시도해주세요.');
    });
};

const handleCollectClick = async () => {

  if (isCollectionOutOfDate.value) {
    emit('show-error', '수거신청 기간이 아닙니다');
    return;
  }

  if (props.challengeType === 'everyone') {
    if (await isParticipated(everyone_round2_progId as number)) {
      const round2Data = await getProgram(everyone_round2_progId as number);
      if (isDateInRangeOfCollection(round2Data.data.program_rounds)) {
        collect?.(props.challengeType, round2Data.data)
          .catch(() => {
            emit('show-error', '수거신청에 실패했습니다. 다시 시도해주세요.');
          });
      } else {
        emit('show-error', '수거신청 기간이 아닙니다');
      }
    } else if (await isParticipated(everyone_round1_progId as number)) {
      const round1Data = await getProgram(everyone_round1_progId as number);
      if (isDateInRangeOfCollection(round1Data.data.program_rounds)) {
        collect?.(props.challengeType, round1Data.data)
            .catch(() => {
              emit('show-error', '수거신청에 실패했습니다. 다시 시도해주세요.');
            });
      }
    } else {
      emit('show-error', '원더플 피플로 선정된 분만 수거 신청을 할 수 있어요.');
    }

  } else {
    collect?.(props.challengeType, undefined)
        .catch(() => {
          emit('show-error', '수거신청에 실패했습니다. 다시 시도해주세요.');
        });
  }


};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.challengeType === 'everyone')
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (__props.challengeType === 'everyone')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(challenges), (challenge, index) => {
          return (_openBlock(), _createBlock(ChallengeCard, {
            key: index,
            subtitle: challenge.subtitle,
            title: challenge.title,
            "application-period-label": "모집일정",
            "application-period": __props.challengeType === 'everyone' ? (challenge.recruitmentFrom && challenge.recruitmentTo ? _unref(formatDateRange)(challenge.recruitmentFrom, challenge.recruitmentTo) : '') : `2025.06.04 - 06.22`,
            "exam-period-label": "수거기간",
            "exam-period": challenge.collectionFrom && challenge.collectionTo ? _unref(formatDateRange)(challenge.collectionFrom, challenge.collectionTo) : '',
            "announcement-label": "참여자 발표",
            "announcement-date": __props.challengeType === 'everyone' ? (challenge.participantAnnouncement ? _unref(formatDate)(challenge.participantAnnouncement) : '') : '모집 마감 후 개별 발표 및 사이트 등록 안내 예정',
            "result-label": "박스발송",
            "result-date": __props.challengeType === 'everyone' ? (challenge.boxDelivery ? _unref(formatDate)(challenge.boxDelivery) : '') : `2025.08.31`,
            "challenge-type": __props.challengeType
          }, {
            default: _withCtx(() => [
              (index === 0)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_1,
                    width: "180",
                    alt: "챌린지 카드 이미지",
                    class: _normalizeClass({'everyone-challenge-card-image-1' : __props.challengeType === 'everyone', 'campus-challenge-card-image-1' : __props.challengeType === 'campus'}),
                    style: {}
                  }, null, 2))
                : _createCommentVNode("", true),
              (index === 0 && __props.challengeType === 'everyone')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_2,
                    width: "180",
                    alt: "챌린지 카드 이미지",
                    class: _normalizeClass(["d-none d-sm-block", {'everyone-challenge-together' : __props.challengeType === 'everyone'}])
                  }, null, 2))
                : _createCommentVNode("", true),
              (index === 0)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 2,
                    src: _imports_2,
                    width: "180",
                    alt: "챌린지 카드 이미지",
                    class: _normalizeClass({'campus-challenge-together' : __props.challengeType === 'campus', 'd-none': __props.challengeType === 'everyone'})
                  }, null, 2))
                : _createCommentVNode("", true),
              (__props.challengeType === 'campus' || index === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                : _createCommentVNode("", true),
              (index === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                : _createCommentVNode("", true),
              (index === 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 5,
                    src: _imports_2,
                    width: "180",
                    class: _normalizeClass(["d-sm-none", {'everyone-challenge-together-2' : __props.challengeType === 'everyone'}]),
                    alt: "챌린지 카드 이미지"
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["subtitle", "title", "application-period", "exam-period", "announcement-date", "result-date", "challenge-type"]))
        }), 128))
      ]),
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (!__props.hideParticipateButton)
          ? (_openBlock(), _createBlock(ColaButton, {
              key: 0,
              title: "참여신청 하러가기",
              "is-out-of-date": _unref(isRecruitmentOutOfDate),
              big: "",
              responsive: true,
              onClick: handleParticipateClick
            }, null, 8, ["is-out-of-date"]))
          : _createCommentVNode("", true),
        _createVNode(ColaButton, {
          title: "수거신청 하러가기",
          "is-out-of-date": _unref(isCollectionOutOfDate),
          responsive: true,
          big: "",
          onClick: handleCollectClick
        }, null, 8, ["is-out-of-date"]),
        (__props.showAdditionalButton)
          ? (_openBlock(), _createBlock(ColaButton, {
              key: 1,
              title: "박스 추가 신청하기",
              responsive: true,
              big: "",
              onClick: handleAdditionalClick
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})